import {Injectable} from '@angular/core';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class CustomPaginatorConfiguration extends MatPaginatorIntl {
  OF_LABEL = 'Of';

  constructor(private translate: TranslateService) {
    super();
    this.translate.onLangChange.subscribe(() => {
      this.getAndInitTranslations();
    });
    this.getAndInitTranslations();
  }

  getAndInitTranslations() {
    this.translate.stream([
      'PAGINATOR.ITEMS_PER_PAGE',
      'PAGINATOR.LAST_PAGE',
      'PAGINATOR.NEXT_PAGE',
      'PAGINATOR.FIRST_PAGE',
      'PAGINATOR.PREVIOUS_PAGE',
      'PAGINATOR.OF_LABEL',
    ]).subscribe(translation => {
      this.itemsPerPageLabel = translation['PAGINATOR.ITEMS_PER_PAGE'];
      this.lastPageLabel = translation['PAGINATOR.LAST_PAGE'];
      this.nextPageLabel = translation['PAGINATOR.NEXT_PAGE'];
      this.firstPageLabel = translation['PAGINATOR.FIRST_PAGE'];
      this.previousPageLabel = translation['PAGINATOR.PREVIOUS_PAGE'];
      this.OF_LABEL = translation['PAGINATOR.OF_LABEL'];
      this.changes.next();
    });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number,) => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.OF_LABEL} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} ${this.OF_LABEL} ${length}`;
  };
}
